import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';

const statusLabel = (status) => {
  if (status === 'accepted') return 'Đã được chấp nhận';
  if (status === 'rejected') return 'Đã bị từ chối';
  return 'Đang chờ';
};

const statusClass = (status) => {
  if (status === 'accepted') return 'badge-success';
  if (status === 'rejected') return 'badge-danger';
  return 'badge-warning';
};

const MySentRequests = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }
    fetchData();
  }, [user, navigate]);

  const fetchData = async () => {
    try {
      const res = await axios.get('/api/items/my/sent-requests');
      setRequests(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Lỗi khi tải danh sách đã xin:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <div className="container" style={{ marginTop: '40px' }}>
      <h1 style={{ marginBottom: '24px' }}>Món đồ tôi đã xin</h1>

      {loading ? (
        <div className="loading">Đang tải...</div>
      ) : requests.length === 0 ? (
        <div className="empty-state">
          <h3>Chưa có yêu cầu nào</h3>
          <p>Bạn chưa gửi yêu cầu xin món đồ nào</p>
        </div>
      ) : (
        <div className="grid">
          {requests.map((req) => (
            <div key={req.id} className="card" style={{ cursor: 'pointer' }} onClick={() => navigate(`/item/${req.item_id}`)}>
              {req.item_image && (
                <img
                  src={req.item_image}
                  alt={req.item_title}
                  style={{ 
                    width: '100%', 
                    height: '180px', 
                    objectFit: 'cover', 
                    borderRadius: '8px',
                    transition: 'opacity 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                  onMouseLeave={(e) => e.target.style.opacity = '1'}
                />
              )}
              <div style={{ marginTop: '12px' }}>
                <h3 
                  style={{ 
                    cursor: 'pointer',
                    transition: 'color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#7b1fa2'}
                  onMouseLeave={(e) => e.target.style.color = ''}
                >
                  {req.item_title}
                </h3>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', margin: '8px 0', flexWrap: 'wrap' }}>
                  <span 
                    className={`badge ${statusClass(req.status)}`}
                    style={req.status === 'rejected' ? {
                      fontSize: '13px',
                      padding: '6px 14px',
                      fontWeight: '700'
                    } : {}}
                  >
                    {statusLabel(req.status)}
                  </span>
                  {req.item_status && (
                    <span className="badge badge-info">Món đồ: {req.item_status === 'taken' ? 'Đã được nhận' : req.item_status}</span>
                  )}
                </div>
                {req.status === 'rejected' && (
                  <div style={{ 
                    marginTop: '8px', 
                    padding: '10px 12px', 
                    background: '#ffebee', 
                    borderRadius: '6px',
                    border: '1px solid #ffcdd2'
                  }}>
                    <p style={{ margin: 0, fontSize: '13px', color: '#c62828', fontWeight: '500' }}>
                      ⚠️ Yêu cầu của bạn đã bị từ chối
                    </p>
                  </div>
                )}
                <p style={{ marginTop: '8px', fontSize: '12px', color: '#777' }}>
                  Gửi lúc: {new Date(req.created_at).toLocaleString('vi-VN')}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MySentRequests;


